/**
 * Configuração dos documentos legais (Política de Privacidade e Termos de Uso).
 * RASCUNHO para validação jurídica: ver docs/juridico/RASCUNHO.md.
 * A versão vem de @barbeiropro/contracts porque o servidor também confere o aceite contra ela.
 */
export { LEGAL_VERSION } from '@barbeiropro/contracts';

/** Data da última atualização do texto (mesma data da versão). */
export const LEGAL_UPDATED_AT = '2026-10-22';

export const COMPANY: {
  name: string;
  contactEmail: string;
  privacyEmail: string;
  forum: string;
  /** exibido só se preenchido */
  cnpj?: string;
  /** exibido só se preenchido */
  address?: string;
} = {
  name: 'Capricornio Tech',
  contactEmail: 'contato@capricorniotech.com.br',
  privacyEmail: 'contato@capricorniotech.com.br',
  forum: 'Franca/SP',
  cnpj: undefined,
  address: undefined,
};

export const PRODUCT = {
  name: 'BarbeiroPro',
  domain: 'barbeiropro.capricorniotech.com.br',
  /** como o estabelecimento cliente é chamado nos textos */
  customerNoun: 'barbearia',
} as const;

export const LEGAL_PATHS = { privacy: '/privacidade', terms: '/termos', accept: '/aceitar-termos' } as const;

/** "22 de outubro de 2026" a partir de AAAA-MM-DD, sem depender de fuso. */
export function formatLegalDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number) as [number, number, number];
  const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
  return `${d} de ${meses[m - 1]} de ${y}`;
}

/** "Franca/SP" -> "Franca, Estado de São Paulo" (só para UF conhecida; senão devolve o texto como está). */
export function forumText(forum: string): string {
  const [city, uf] = forum.split('/');
  return city && uf === 'SP' ? `${city}, Estado de São Paulo` : forum;
}
